import { Inject, Injectable } from '@angular/core';

import {
  AuthenticationService,
  ISwitchAccount,
  IUserAccount,
} from '@libs/authentication/services';
import { APP_CONFIG } from '@libs/configs';
import { App, CollectionResponse } from '@libs/types';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AccountPickerService {
  get account$() {
    return this.authService.account$;
  }

  constructor(
    private authService: AuthenticationService,
    @Inject(APP_CONFIG) private appConfig: any,
  ) {
    this.appConfig = appConfig.app;
  }

  canUseAccountPicker(): boolean {
    const user = this.authService.user$.getValue();
    const permissionId: string = user?.jwt?.permissionId;
    return this.appConfig === App.Employer && !!permissionId;
  }

  getUserAccounts(): Observable<IUserAccount[]> {
    if (this.canUseAccountPicker()) {
      const user = this.authService.user$.getValue();
      return this.authService.getUserAccounts(user.token).pipe(
        switchMap((response: CollectionResponse<IUserAccount>) => {
          const userAccounts = response.list.sort(
            (a: IUserAccount, b: IUserAccount) =>
              a.accountName.localeCompare(b.accountName),
          );
          return of(userAccounts);
        }),
      );
    }
    return of([]);
  }

  switchAccount(permissionId: string): void {
    const token = this.authService.user$.getValue()?.token;
    const request: ISwitchAccount = {
      permissionId: permissionId,
      token: token,
    };
    this.authService.switchToDifferentAccount(request);
  }
}
